import React from "react";
import BlogCard from "./blogCard";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slickSlider.scss";

const SlickSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1370,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
    // responsive: [
    //   {
    //     breakpoint: 1330,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 1,
    //     },
    //   },
    // ],
  };

  const blogimg1 = "/images/home/blogcard1.png";
  const blogimg2 = "/images/home/blogcard2.webp";
  const blogimg3 = "/images/home/blogcard3.png";

  const bloghead1 = "Building Brilliance";
  const bloghead2 = "Easy Contracts";
  const bloghead3 = "Masterful Construct";

  const blogpara1 =
    "Enter into a world where construction transcends into an art form—our service embodies building brilliance. Each project is a symphony of innovation and precision, creating architectural poetry.";
  const blogpara2 =
    "Experience the future of hassle-free agreements with us. Streamline your paperwork, simplify the process, and make your projects smoother than ever before.";
  const blogpara3 =
    "Precision, innovation, and artistic finesse converge in Group LanDev AI's construction, where every project is a testament to timeless brilliance.";

  const link1 = "/blogContent";
  const link2 = "/blogEffortless";
  const link3 = "/blogMasterful";

  return (
    <>
      <Slider {...settings} className="custom-slider">
        <div className="h-center">
          <BlogCard
            blogImg={blogimg1}
            blogHeading={bloghead1}
            blogParagraphs={blogpara1}
            link={link1}
          />
        </div>
        <div className="h-center">
          <BlogCard
            blogImg={blogimg2}
            blogHeading={bloghead2}
            blogParagraphs={blogpara2}
            link={link2}
          />
        </div>
        <div className="h-center">
          <BlogCard
            blogImg={blogimg3}
            blogHeading={bloghead3}
            blogParagraphs={blogpara3}
            link={link3}
          />
        </div>
        <div className="h-center">
          <BlogCard
            blogImg={blogimg1}
            blogHeading={bloghead1}
            blogParagraphs={blogpara1}
            link={link1}
          />
        </div>
        <div className="h-center">
          <BlogCard
            blogImg={blogimg2}
            blogHeading={bloghead2}
            blogParagraphs={blogpara2}
            link={link2}
          />
        </div>
        <div className="h-center">
          <BlogCard
            blogImg={blogimg3}
            blogHeading={bloghead3}
            blogParagraphs={blogpara3}
            link={link3}
          />
        </div>
        {/* Add more slides as needed */}
      </Slider>
    </>
  );
};

export default SlickSlider;
